import React from 'react';
import { Moon, Sun, Music, MapPin, Users, Zap } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="space-y-12 animate-fade-in max-w-5xl mx-auto">
      {/* Header */}
      <div className="text-center space-y-4">
        <h1 className="text-5xl font-light tracking-wider">
          AFTER.AM
        </h1>
        <p className="text-xl text-[#D4A574]">
          Electronic music culture in Lisboa
        </p>
      </div>

      {/* Vision Section */}
      <section className="card-dark p-8 space-y-6">
        <div className="flex items-center gap-3 mb-6">
          <Moon className="text-[#D4A574]" size={28} />
          <h2 className="text-2xl font-light">Project Vision</h2>
        </div>
        
        <div className="prose prose-invert max-w-none space-y-4">
          <p className="text-lg leading-relaxed">
            After.am is een high-concept evenementenplatform dat minimal en tech house muziek 
            verbindt met de overgang van nacht naar ochtend. Het is bedoeld voor een publiek 
            dat kwaliteit boven kwantiteit kiest.
          </p>
          
          <p className="text-lg leading-relaxed">
            De naam After.am verwijst naar het tijdstip ("na middernacht") én het idee dat 
            dit "na" iets komt — een verdieping, een voortzetting, een reset.
          </p>
        </div>
      </section>

      {/* Why Section */}
      <section className="card-dark p-8 space-y-6">
        <div className="flex items-center gap-3 mb-6">
          <Sun className="text-[#D4A574]" size={28} />
          <h2 className="text-2xl font-light">Waarom</h2>
        </div>
        
        <p className="text-lg leading-relaxed">
          Omdat er een cultuur ontbreekt waar 'early morning' events net zo stijlvol en 
          zorgvuldig geprogrammeerd zijn als nachtelijke clubnachten. We creëren een ruimte 
          waar de transitie van nacht naar dag wordt gevierd met dezelfde aandacht voor 
          kwaliteit, atmosfeer en muzikale selectie.
        </p>
      </section>

      {/* How Section */}
      <section className="card-dark p-8 space-y-6">
        <div className="flex items-center gap-3 mb-6">
          <Zap className="text-[#D4A574]" size={28} />
          <h2 className="text-2xl font-light">Hoe</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="space-y-3">
            <MapPin className="text-[#888888]" size={24} />
            <h3 className="font-medium">Unieke Locaties</h3>
            <p className="text-sm text-[#888888]">
              Zorgvuldig geselecteerde venues die de essentie van de after-hours cultuur belichamen
            </p>
          </div>
          
          <div className="space-y-3">
            <Users className="text-[#888888]" size={24} />
            <h3 className="font-medium">Selectieve Communicatie</h3>
            <p className="text-sm text-[#888888]">
              Doelgerichte benadering van een toegewijd publiek dat de waarde van deze momenten begrijpt
            </p>
          </div>
          
          <div className="space-y-3">
            <Music className="text-[#888888]" size={24} />
            <h3 className="font-medium">Slimme Eventstructuur</h3>
            <p className="text-sm text-[#888888]">
              Eigen events gecombineerd met afterparty's voor een naadloze overgang
            </p>
          </div>
        </div>
      </section>

      {/* Intention Section */}
      <section className="card-dark p-8 space-y-6">
        <div className="flex items-center gap-3 mb-6">
          <Music className="text-[#D4A574]" size={28} />
          <h2 className="text-2xl font-light">Intentie</h2>
        </div>
        
        <div className="bg-[#0A0A0A] p-6 rounded-lg border border-[#D4A574]/20">
          <p className="text-lg leading-relaxed italic">
            Dit is de broncode van de visie. Als er ooit wordt getwijfeld over stijl, toon, 
            doelgroep of beslissing: deze tekst is je ijkpunt. After.am staat voor kwaliteit, 
            authenticiteit en het vieren van de magische momenten tussen nacht en dag.
          </p>
        </div>
      </section>

      {/* Core Values */}
      <section className="card-dark p-8">
        <h2 className="text-2xl font-light mb-6">Core Values</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-4">
            <h3 className="text-[#D4A574] font-medium">Musical Excellence</h3>
            <ul className="space-y-2 text-sm text-[#888888]">
              <li>• Curated minimal & tech house selection</li>
              <li>• Support for emerging local talent</li>
              <li>• International artist collaborations</li>
            </ul>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-[#D4A574] font-medium">Community First</h3>
            <ul className="space-y-2 text-sm text-[#888888]">
              <li>• Intimate, considered experiences</li>
              <li>• Respectful, aware audience</li>
              <li>• Sustainable event practices</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="text-center py-8">
        <p className="text-[#888888]">
          For inquiries: <a href="mailto:info@after.am" className="text-[#D4A574] hover:underline">info@after.am</a>
        </p>
      </section>
    </div>
  );
};

export default AboutPage;